/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Voyager API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetV1JobsJobIdAckBolSignature200,
  GetV1JobsJobIdAckBolSignature400,
  GetV1JobsJobIdAckBolSignature401,
  GetV1JobsJobIdAckBolSignature403,
  GetV1JobsJobIdAckBolSignature404,
  GetV1JobsJobIdAckBolSignature422,
  GetV1JobsJobIdAckBolSignature500,
  GetV1JobsJobIdAckBolStatus200,
  GetV1JobsJobIdAckBolStatus400,
  GetV1JobsJobIdAckBolStatus401,
  GetV1JobsJobIdAckBolStatus403,
  GetV1JobsJobIdAckBolStatus404,
  GetV1JobsJobIdAckBolStatus422,
  GetV1JobsJobIdAckBolStatus500,
  GetV1JobsJobIdAckFinalDelivery200,
  GetV1JobsJobIdAckFinalDelivery400,
  GetV1JobsJobIdAckFinalDelivery401,
  GetV1JobsJobIdAckFinalDelivery403,
  GetV1JobsJobIdAckFinalDelivery404,
  GetV1JobsJobIdAckFinalDelivery422,
  GetV1JobsJobIdAckFinalDelivery500,
  GetV1JobsJobIdAckPaymentDetails200,
  GetV1JobsJobIdAckPaymentDetails400,
  GetV1JobsJobIdAckPaymentDetails401,
  GetV1JobsJobIdAckPaymentDetails403,
  GetV1JobsJobIdAckPaymentDetails404,
  GetV1JobsJobIdAckPaymentDetails422,
  GetV1JobsJobIdAckPaymentDetails500,
  GetV1JobsJobIdBolContacts200,
  GetV1JobsJobIdBolContacts400,
  GetV1JobsJobIdBolContacts401,
  GetV1JobsJobIdBolContacts403,
  GetV1JobsJobIdBolContacts404,
  GetV1JobsJobIdBolContacts422,
  GetV1JobsJobIdBolContacts500,
  GetV1JobsJobIdBolDetail200,
  GetV1JobsJobIdBolDetail400,
  GetV1JobsJobIdBolDetail401,
  GetV1JobsJobIdBolDetail403,
  GetV1JobsJobIdBolDetail404,
  GetV1JobsJobIdBolDetail422,
  GetV1JobsJobIdBolDetail500,
  GetV1JobsJobIdBolMoveDetail200,
  GetV1JobsJobIdBolMoveDetail400,
  GetV1JobsJobIdBolMoveDetail401,
  GetV1JobsJobIdBolMoveDetail403,
  GetV1JobsJobIdBolMoveDetail404,
  GetV1JobsJobIdBolMoveDetail422,
  GetV1JobsJobIdBolMoveDetail500,
  GetV1JobsJobIdBolSignatures200,
  GetV1JobsJobIdBolSignatures400,
  GetV1JobsJobIdBolSignatures401,
  GetV1JobsJobIdBolSignatures403,
  GetV1JobsJobIdBolSignatures404,
  GetV1JobsJobIdBolSignatures422,
  GetV1JobsJobIdBolSignatures500,
  GetV1JobsJobIdBolValuation200,
  GetV1JobsJobIdBolValuation400,
  GetV1JobsJobIdBolValuation401,
  GetV1JobsJobIdBolValuation403,
  GetV1JobsJobIdBolValuation404,
  GetV1JobsJobIdBolValuation422,
  GetV1JobsJobIdBolValuation500,
  GetV1PaperworkContent200,
  GetV1PaperworkContent400,
  GetV1PaperworkContent401,
  GetV1PaperworkContent403,
  GetV1PaperworkContent404,
  GetV1PaperworkContent422,
  GetV1PaperworkContent500,
  GetV1PaperworkContentCustomerContacts200,
  GetV1PaperworkContentCustomerContacts400,
  GetV1PaperworkContentCustomerContacts401,
  GetV1PaperworkContentCustomerContacts403,
  GetV1PaperworkContentCustomerContacts404,
  GetV1PaperworkContentCustomerContacts422,
  GetV1PaperworkContentCustomerContacts500,
  GetV1PaperworkContentPackingMaterials200,
  GetV1PaperworkContentPackingMaterials400,
  GetV1PaperworkContentPackingMaterials401,
  GetV1PaperworkContentPackingMaterials403,
  GetV1PaperworkContentPackingMaterials404,
  GetV1PaperworkContentPackingMaterials422,
  GetV1PaperworkContentPackingMaterials500,
  PatchV1JobsJobIdAckSignaturesDateTime200,
  PatchV1JobsJobIdAckSignaturesDateTime400,
  PatchV1JobsJobIdAckSignaturesDateTime401,
  PatchV1JobsJobIdAckSignaturesDateTime403,
  PatchV1JobsJobIdAckSignaturesDateTime404,
  PatchV1JobsJobIdAckSignaturesDateTime422,
  PatchV1JobsJobIdAckSignaturesDateTime500,
  PatchV1JobsJobIdAckSignaturesDateTimeBody,
  PostV1JobsJobIdBolComplete200,
  PostV1JobsJobIdBolComplete400,
  PostV1JobsJobIdBolComplete401,
  PostV1JobsJobIdBolComplete403,
  PostV1JobsJobIdBolComplete404,
  PostV1JobsJobIdBolComplete422,
  PostV1JobsJobIdBolComplete500,
  PostV1JobsJobIdBolContactsSend200,
  PostV1JobsJobIdBolContactsSend400,
  PostV1JobsJobIdBolContactsSend401,
  PostV1JobsJobIdBolContactsSend403,
  PostV1JobsJobIdBolContactsSend404,
  PostV1JobsJobIdBolContactsSend422,
  PostV1JobsJobIdBolContactsSend500,
  PostV1JobsJobIdBolEmail200,
  PostV1JobsJobIdBolEmail400,
  PostV1JobsJobIdBolEmail401,
  PostV1JobsJobIdBolEmail403,
  PostV1JobsJobIdBolEmail404,
  PostV1JobsJobIdBolEmail422,
  PostV1JobsJobIdBolEmail500,
  PostV1JobsJobIdBolSignaturesCopy200,
  PostV1JobsJobIdBolSignaturesCopy400,
  PostV1JobsJobIdBolSignaturesCopy401,
  PostV1JobsJobIdBolSignaturesCopy403,
  PostV1JobsJobIdBolSignaturesCopy404,
  PostV1JobsJobIdBolSignaturesCopy422,
  PostV1JobsJobIdBolSignaturesCopy500,
  PostV1JobsJobIdBolSignaturesCopyBody,
  PostV1JobsJobIdBolSignaturesUploadUrl200,
  PostV1JobsJobIdBolSignaturesUploadUrl400,
  PostV1JobsJobIdBolSignaturesUploadUrl401,
  PostV1JobsJobIdBolSignaturesUploadUrl403,
  PostV1JobsJobIdBolSignaturesUploadUrl404,
  PostV1JobsJobIdBolSignaturesUploadUrl422,
  PostV1JobsJobIdBolSignaturesUploadUrl500,
  PostV1JobsJobIdBolSignaturesUploadUrlBody,
  PostV1JobsJobIdBolValuationPremium200,
  PostV1JobsJobIdBolValuationPremium400,
  PostV1JobsJobIdBolValuationPremium401,
  PostV1JobsJobIdBolValuationPremium403,
  PostV1JobsJobIdBolValuationPremium404,
  PostV1JobsJobIdBolValuationPremium422,
  PostV1JobsJobIdBolValuationPremium500,
  PostV1JobsJobIdBolValuationPremiumBody,
  PutV1JobsJobIdAckCustomerRemark200,
  PutV1JobsJobIdAckCustomerRemark400,
  PutV1JobsJobIdAckCustomerRemark401,
  PutV1JobsJobIdAckCustomerRemark403,
  PutV1JobsJobIdAckCustomerRemark404,
  PutV1JobsJobIdAckCustomerRemark422,
  PutV1JobsJobIdAckCustomerRemark500,
  PutV1JobsJobIdAckCustomerRemarkBody,
  PutV1JobsJobIdAckSignaturesBatch200,
  PutV1JobsJobIdAckSignaturesBatch400,
  PutV1JobsJobIdAckSignaturesBatch401,
  PutV1JobsJobIdAckSignaturesBatch403,
  PutV1JobsJobIdAckSignaturesBatch404,
  PutV1JobsJobIdAckSignaturesBatch422,
  PutV1JobsJobIdAckSignaturesBatch500,
  PutV1JobsJobIdAckSignaturesBatchBody,
  PutV1JobsJobIdBolCustomerContacts200,
  PutV1JobsJobIdBolCustomerContacts400,
  PutV1JobsJobIdBolCustomerContacts401,
  PutV1JobsJobIdBolCustomerContacts403,
  PutV1JobsJobIdBolCustomerContacts404,
  PutV1JobsJobIdBolCustomerContacts422,
  PutV1JobsJobIdBolCustomerContacts500,
  PutV1JobsJobIdBolCustomerContactsBody,
  PutV1JobsJobIdBolSignaturesType2200,
  PutV1JobsJobIdBolSignaturesType2400,
  PutV1JobsJobIdBolSignaturesType2401,
  PutV1JobsJobIdBolSignaturesType2403,
  PutV1JobsJobIdBolSignaturesType2404,
  PutV1JobsJobIdBolSignaturesType2422,
  PutV1JobsJobIdBolSignaturesType2500,
  PutV1JobsJobIdBolSignaturesType2Body,
  PutV1JobsJobIdBolValuation200,
  PutV1JobsJobIdBolValuation400,
  PutV1JobsJobIdBolValuation401,
  PutV1JobsJobIdBolValuation403,
  PutV1JobsJobIdBolValuation404,
  PutV1JobsJobIdBolValuation422,
  PutV1JobsJobIdBolValuation500,
  PutV1JobsJobIdBolValuationBody
} from '../../schemas';

import { fetcher } from '../../../lib/api-client.ts';
import type { ErrorType , BodyType } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * The job's charges, deposits and balance due as the customer acknowledges them
 */
export const getV1JobsJobIdAckPaymentDetails = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdAckPaymentDetails200>(
      {url: `/v1/jobs/${jobId}/ack/payment-details`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdAckPaymentDetailsQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/ack/payment-details`
    ] as const;
    }


export const getGetV1JobsJobIdAckPaymentDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError = ErrorType<GetV1JobsJobIdAckPaymentDetails400 | GetV1JobsJobIdAckPaymentDetails401 | GetV1JobsJobIdAckPaymentDetails403 | GetV1JobsJobIdAckPaymentDetails404 | GetV1JobsJobIdAckPaymentDetails422 | GetV1JobsJobIdAckPaymentDetails500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdAckPaymentDetailsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>> = ({ signal }) => getV1JobsJobIdAckPaymentDetails(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdAckPaymentDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>>
export type GetV1JobsJobIdAckPaymentDetailsQueryError = ErrorType<GetV1JobsJobIdAckPaymentDetails400 | GetV1JobsJobIdAckPaymentDetails401 | GetV1JobsJobIdAckPaymentDetails403 | GetV1JobsJobIdAckPaymentDetails404 | GetV1JobsJobIdAckPaymentDetails422 | GetV1JobsJobIdAckPaymentDetails500>


export function useGetV1JobsJobIdAckPaymentDetails<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError = ErrorType<GetV1JobsJobIdAckPaymentDetails400 | GetV1JobsJobIdAckPaymentDetails401 | GetV1JobsJobIdAckPaymentDetails403 | GetV1JobsJobIdAckPaymentDetails404 | GetV1JobsJobIdAckPaymentDetails422 | GetV1JobsJobIdAckPaymentDetails500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckPaymentDetails<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError = ErrorType<GetV1JobsJobIdAckPaymentDetails400 | GetV1JobsJobIdAckPaymentDetails401 | GetV1JobsJobIdAckPaymentDetails403 | GetV1JobsJobIdAckPaymentDetails404 | GetV1JobsJobIdAckPaymentDetails422 | GetV1JobsJobIdAckPaymentDetails500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckPaymentDetails<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError = ErrorType<GetV1JobsJobIdAckPaymentDetails400 | GetV1JobsJobIdAckPaymentDetails401 | GetV1JobsJobIdAckPaymentDetails403 | GetV1JobsJobIdAckPaymentDetails404 | GetV1JobsJobIdAckPaymentDetails422 | GetV1JobsJobIdAckPaymentDetails500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdAckPaymentDetails<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError = ErrorType<GetV1JobsJobIdAckPaymentDetails400 | GetV1JobsJobIdAckPaymentDetails401 | GetV1JobsJobIdAckPaymentDetails403 | GetV1JobsJobIdAckPaymentDetails404 | GetV1JobsJobIdAckPaymentDetails422 | GetV1JobsJobIdAckPaymentDetails500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckPaymentDetails>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdAckPaymentDetailsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The final delivery acknowledgment copy and the remark the customer left so far
 */
export const getV1JobsJobIdAckFinalDelivery = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdAckFinalDelivery200>(
      {url: `/v1/jobs/${jobId}/ack/final-delivery`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdAckFinalDeliveryQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/ack/final-delivery`
    ] as const;
    }


export const getGetV1JobsJobIdAckFinalDeliveryQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError = ErrorType<GetV1JobsJobIdAckFinalDelivery400 | GetV1JobsJobIdAckFinalDelivery401 | GetV1JobsJobIdAckFinalDelivery403 | GetV1JobsJobIdAckFinalDelivery404 | GetV1JobsJobIdAckFinalDelivery422 | GetV1JobsJobIdAckFinalDelivery500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdAckFinalDeliveryQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>> = ({ signal }) => getV1JobsJobIdAckFinalDelivery(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdAckFinalDeliveryQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>>
export type GetV1JobsJobIdAckFinalDeliveryQueryError = ErrorType<GetV1JobsJobIdAckFinalDelivery400 | GetV1JobsJobIdAckFinalDelivery401 | GetV1JobsJobIdAckFinalDelivery403 | GetV1JobsJobIdAckFinalDelivery404 | GetV1JobsJobIdAckFinalDelivery422 | GetV1JobsJobIdAckFinalDelivery500>


export function useGetV1JobsJobIdAckFinalDelivery<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError = ErrorType<GetV1JobsJobIdAckFinalDelivery400 | GetV1JobsJobIdAckFinalDelivery401 | GetV1JobsJobIdAckFinalDelivery403 | GetV1JobsJobIdAckFinalDelivery404 | GetV1JobsJobIdAckFinalDelivery422 | GetV1JobsJobIdAckFinalDelivery500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckFinalDelivery<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError = ErrorType<GetV1JobsJobIdAckFinalDelivery400 | GetV1JobsJobIdAckFinalDelivery401 | GetV1JobsJobIdAckFinalDelivery403 | GetV1JobsJobIdAckFinalDelivery404 | GetV1JobsJobIdAckFinalDelivery422 | GetV1JobsJobIdAckFinalDelivery500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckFinalDelivery<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError = ErrorType<GetV1JobsJobIdAckFinalDelivery400 | GetV1JobsJobIdAckFinalDelivery401 | GetV1JobsJobIdAckFinalDelivery403 | GetV1JobsJobIdAckFinalDelivery404 | GetV1JobsJobIdAckFinalDelivery422 | GetV1JobsJobIdAckFinalDelivery500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdAckFinalDelivery<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError = ErrorType<GetV1JobsJobIdAckFinalDelivery400 | GetV1JobsJobIdAckFinalDelivery401 | GetV1JobsJobIdAckFinalDelivery403 | GetV1JobsJobIdAckFinalDelivery404 | GetV1JobsJobIdAckFinalDelivery422 | GetV1JobsJobIdAckFinalDelivery500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckFinalDelivery>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdAckFinalDeliveryQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Record the customer's remark on the final delivery acknowledgment
 */
export const putV1JobsJobIdAckCustomerRemark = (
    jobId: string,
    putV1JobsJobIdAckCustomerRemarkBody: BodyType<PutV1JobsJobIdAckCustomerRemarkBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PutV1JobsJobIdAckCustomerRemark200>(
      {url: `/v1/jobs/${jobId}/ack/customer-remark`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV1JobsJobIdAckCustomerRemarkBody, signal
    },
      options);
    }




export const getPutV1JobsJobIdAckCustomerRemarkMutationKey = () => ['putV1JobsJobIdAckCustomerRemark'] as const;

export const getPutV1JobsJobIdAckCustomerRemarkMutationOptions = <TError = ErrorType<PutV1JobsJobIdAckCustomerRemark400 | PutV1JobsJobIdAckCustomerRemark401 | PutV1JobsJobIdAckCustomerRemark403 | PutV1JobsJobIdAckCustomerRemark404 | PutV1JobsJobIdAckCustomerRemark422 | PutV1JobsJobIdAckCustomerRemark500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdAckCustomerRemark>>, TError,PutV1JobsJobIdAckCustomerRemarkMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdAckCustomerRemark>>, TError,PutV1JobsJobIdAckCustomerRemarkMutationVariables, TContext> => {

const mutationKey = getPutV1JobsJobIdAckCustomerRemarkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV1JobsJobIdAckCustomerRemark>>, PutV1JobsJobIdAckCustomerRemarkMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  putV1JobsJobIdAckCustomerRemark(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV1JobsJobIdAckCustomerRemarkMutationResult = NonNullable<Awaited<ReturnType<typeof putV1JobsJobIdAckCustomerRemark>>>
    export type PutV1JobsJobIdAckCustomerRemarkMutationBody = BodyType<PutV1JobsJobIdAckCustomerRemarkBody>
    export type PutV1JobsJobIdAckCustomerRemarkMutationError = ErrorType<PutV1JobsJobIdAckCustomerRemark400 | PutV1JobsJobIdAckCustomerRemark401 | PutV1JobsJobIdAckCustomerRemark403 | PutV1JobsJobIdAckCustomerRemark404 | PutV1JobsJobIdAckCustomerRemark422 | PutV1JobsJobIdAckCustomerRemark500>
    export type PutV1JobsJobIdAckCustomerRemarkMutationVariables = {jobId: string;data: BodyType<PutV1JobsJobIdAckCustomerRemarkBody>}

    export const usePutV1JobsJobIdAckCustomerRemark = <TError = ErrorType<PutV1JobsJobIdAckCustomerRemark400 | PutV1JobsJobIdAckCustomerRemark401 | PutV1JobsJobIdAckCustomerRemark403 | PutV1JobsJobIdAckCustomerRemark404 | PutV1JobsJobIdAckCustomerRemark422 | PutV1JobsJobIdAckCustomerRemark500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdAckCustomerRemark>>, TError,PutV1JobsJobIdAckCustomerRemarkMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV1JobsJobIdAckCustomerRemark>>,
        TError,
        PutV1JobsJobIdAckCustomerRemarkMutationVariables,
        TContext
      > => {
      return useMutation(getPutV1JobsJobIdAckCustomerRemarkMutationOptions(options), queryClient);
    }
    /**
 * Which bill of lading documents were signed on the job, and when
 */
export const getV1JobsJobIdAckBolStatus = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdAckBolStatus200>(
      {url: `/v1/jobs/${jobId}/ack/bol-status`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdAckBolStatusQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/ack/bol-status`
    ] as const;
    }


export const getGetV1JobsJobIdAckBolStatusQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError = ErrorType<GetV1JobsJobIdAckBolStatus400 | GetV1JobsJobIdAckBolStatus401 | GetV1JobsJobIdAckBolStatus403 | GetV1JobsJobIdAckBolStatus404 | GetV1JobsJobIdAckBolStatus422 | GetV1JobsJobIdAckBolStatus500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdAckBolStatusQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>> = ({ signal }) => getV1JobsJobIdAckBolStatus(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdAckBolStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>>
export type GetV1JobsJobIdAckBolStatusQueryError = ErrorType<GetV1JobsJobIdAckBolStatus400 | GetV1JobsJobIdAckBolStatus401 | GetV1JobsJobIdAckBolStatus403 | GetV1JobsJobIdAckBolStatus404 | GetV1JobsJobIdAckBolStatus422 | GetV1JobsJobIdAckBolStatus500>


export function useGetV1JobsJobIdAckBolStatus<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError = ErrorType<GetV1JobsJobIdAckBolStatus400 | GetV1JobsJobIdAckBolStatus401 | GetV1JobsJobIdAckBolStatus403 | GetV1JobsJobIdAckBolStatus404 | GetV1JobsJobIdAckBolStatus422 | GetV1JobsJobIdAckBolStatus500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckBolStatus<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError = ErrorType<GetV1JobsJobIdAckBolStatus400 | GetV1JobsJobIdAckBolStatus401 | GetV1JobsJobIdAckBolStatus403 | GetV1JobsJobIdAckBolStatus404 | GetV1JobsJobIdAckBolStatus422 | GetV1JobsJobIdAckBolStatus500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckBolStatus<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError = ErrorType<GetV1JobsJobIdAckBolStatus400 | GetV1JobsJobIdAckBolStatus401 | GetV1JobsJobIdAckBolStatus403 | GetV1JobsJobIdAckBolStatus404 | GetV1JobsJobIdAckBolStatus422 | GetV1JobsJobIdAckBolStatus500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdAckBolStatus<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError = ErrorType<GetV1JobsJobIdAckBolStatus400 | GetV1JobsJobIdAckBolStatus401 | GetV1JobsJobIdAckBolStatus403 | GetV1JobsJobIdAckBolStatus404 | GetV1JobsJobIdAckBolStatus422 | GetV1JobsJobIdAckBolStatus500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolStatus>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdAckBolStatusQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Whether the bill of lading was signed on the driver tablet, so the acknowledgment can be signed
 */
export const getV1JobsJobIdAckBolSignature = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdAckBolSignature200>(
      {url: `/v1/jobs/${jobId}/ack/bol-signature`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdAckBolSignatureQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/ack/bol-signature`
    ] as const;
    }


export const getGetV1JobsJobIdAckBolSignatureQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError = ErrorType<GetV1JobsJobIdAckBolSignature400 | GetV1JobsJobIdAckBolSignature401 | GetV1JobsJobIdAckBolSignature403 | GetV1JobsJobIdAckBolSignature404 | GetV1JobsJobIdAckBolSignature422 | GetV1JobsJobIdAckBolSignature500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdAckBolSignatureQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>> = ({ signal }) => getV1JobsJobIdAckBolSignature(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdAckBolSignatureQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>>
export type GetV1JobsJobIdAckBolSignatureQueryError = ErrorType<GetV1JobsJobIdAckBolSignature400 | GetV1JobsJobIdAckBolSignature401 | GetV1JobsJobIdAckBolSignature403 | GetV1JobsJobIdAckBolSignature404 | GetV1JobsJobIdAckBolSignature422 | GetV1JobsJobIdAckBolSignature500>


export function useGetV1JobsJobIdAckBolSignature<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError = ErrorType<GetV1JobsJobIdAckBolSignature400 | GetV1JobsJobIdAckBolSignature401 | GetV1JobsJobIdAckBolSignature403 | GetV1JobsJobIdAckBolSignature404 | GetV1JobsJobIdAckBolSignature422 | GetV1JobsJobIdAckBolSignature500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckBolSignature<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError = ErrorType<GetV1JobsJobIdAckBolSignature400 | GetV1JobsJobIdAckBolSignature401 | GetV1JobsJobIdAckBolSignature403 | GetV1JobsJobIdAckBolSignature404 | GetV1JobsJobIdAckBolSignature422 | GetV1JobsJobIdAckBolSignature500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdAckBolSignature<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError = ErrorType<GetV1JobsJobIdAckBolSignature400 | GetV1JobsJobIdAckBolSignature401 | GetV1JobsJobIdAckBolSignature403 | GetV1JobsJobIdAckBolSignature404 | GetV1JobsJobIdAckBolSignature422 | GetV1JobsJobIdAckBolSignature500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdAckBolSignature<TData = Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError = ErrorType<GetV1JobsJobIdAckBolSignature400 | GetV1JobsJobIdAckBolSignature401 | GetV1JobsJobIdAckBolSignature403 | GetV1JobsJobIdAckBolSignature404 | GetV1JobsJobIdAckBolSignature422 | GetV1JobsJobIdAckBolSignature500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdAckBolSignature>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdAckBolSignatureQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Record the customer's signature file for a document and return its upload or read url
 */
export const putV1JobsJobIdAckSignaturesBatch = (
    jobId: string,
    putV1JobsJobIdAckSignaturesBatchBody: BodyType<PutV1JobsJobIdAckSignaturesBatchBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PutV1JobsJobIdAckSignaturesBatch200>(
      {url: `/v1/jobs/${jobId}/ack/signatures/batch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV1JobsJobIdAckSignaturesBatchBody, signal
    },
      options);
    }




export const getPutV1JobsJobIdAckSignaturesBatchMutationKey = () => ['putV1JobsJobIdAckSignaturesBatch'] as const;

export const getPutV1JobsJobIdAckSignaturesBatchMutationOptions = <TError = ErrorType<PutV1JobsJobIdAckSignaturesBatch400 | PutV1JobsJobIdAckSignaturesBatch401 | PutV1JobsJobIdAckSignaturesBatch403 | PutV1JobsJobIdAckSignaturesBatch404 | PutV1JobsJobIdAckSignaturesBatch422 | PutV1JobsJobIdAckSignaturesBatch500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdAckSignaturesBatch>>, TError,PutV1JobsJobIdAckSignaturesBatchMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdAckSignaturesBatch>>, TError,PutV1JobsJobIdAckSignaturesBatchMutationVariables, TContext> => {

const mutationKey = getPutV1JobsJobIdAckSignaturesBatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV1JobsJobIdAckSignaturesBatch>>, PutV1JobsJobIdAckSignaturesBatchMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  putV1JobsJobIdAckSignaturesBatch(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV1JobsJobIdAckSignaturesBatchMutationResult = NonNullable<Awaited<ReturnType<typeof putV1JobsJobIdAckSignaturesBatch>>>
    export type PutV1JobsJobIdAckSignaturesBatchMutationBody = BodyType<PutV1JobsJobIdAckSignaturesBatchBody>
    export type PutV1JobsJobIdAckSignaturesBatchMutationError = ErrorType<PutV1JobsJobIdAckSignaturesBatch400 | PutV1JobsJobIdAckSignaturesBatch401 | PutV1JobsJobIdAckSignaturesBatch403 | PutV1JobsJobIdAckSignaturesBatch404 | PutV1JobsJobIdAckSignaturesBatch422 | PutV1JobsJobIdAckSignaturesBatch500>
    export type PutV1JobsJobIdAckSignaturesBatchMutationVariables = {jobId: string;data: BodyType<PutV1JobsJobIdAckSignaturesBatchBody>}

    export const usePutV1JobsJobIdAckSignaturesBatch = <TError = ErrorType<PutV1JobsJobIdAckSignaturesBatch400 | PutV1JobsJobIdAckSignaturesBatch401 | PutV1JobsJobIdAckSignaturesBatch403 | PutV1JobsJobIdAckSignaturesBatch404 | PutV1JobsJobIdAckSignaturesBatch422 | PutV1JobsJobIdAckSignaturesBatch500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdAckSignaturesBatch>>, TError,PutV1JobsJobIdAckSignaturesBatchMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV1JobsJobIdAckSignaturesBatch>>,
        TError,
        PutV1JobsJobIdAckSignaturesBatchMutationVariables,
        TContext
      > => {
      return useMutation(getPutV1JobsJobIdAckSignaturesBatchMutationOptions(options), queryClient);
    }
    /**
 * Record when the customer signed a document
 */
export const patchV1JobsJobIdAckSignaturesDateTime = (
    jobId: string,
    patchV1JobsJobIdAckSignaturesDateTimeBody: BodyType<PatchV1JobsJobIdAckSignaturesDateTimeBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PatchV1JobsJobIdAckSignaturesDateTime200>(
      {url: `/v1/jobs/${jobId}/ack/signatures/date-time`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchV1JobsJobIdAckSignaturesDateTimeBody, signal
    },
      options);
    }




export const getPatchV1JobsJobIdAckSignaturesDateTimeMutationKey = () => ['patchV1JobsJobIdAckSignaturesDateTime'] as const;

export const getPatchV1JobsJobIdAckSignaturesDateTimeMutationOptions = <TError = ErrorType<PatchV1JobsJobIdAckSignaturesDateTime400 | PatchV1JobsJobIdAckSignaturesDateTime401 | PatchV1JobsJobIdAckSignaturesDateTime403 | PatchV1JobsJobIdAckSignaturesDateTime404 | PatchV1JobsJobIdAckSignaturesDateTime422 | PatchV1JobsJobIdAckSignaturesDateTime500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchV1JobsJobIdAckSignaturesDateTime>>, TError,PatchV1JobsJobIdAckSignaturesDateTimeMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof patchV1JobsJobIdAckSignaturesDateTime>>, TError,PatchV1JobsJobIdAckSignaturesDateTimeMutationVariables, TContext> => {

const mutationKey = getPatchV1JobsJobIdAckSignaturesDateTimeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchV1JobsJobIdAckSignaturesDateTime>>, PatchV1JobsJobIdAckSignaturesDateTimeMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  patchV1JobsJobIdAckSignaturesDateTime(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchV1JobsJobIdAckSignaturesDateTimeMutationResult = NonNullable<Awaited<ReturnType<typeof patchV1JobsJobIdAckSignaturesDateTime>>>
    export type PatchV1JobsJobIdAckSignaturesDateTimeMutationBody = BodyType<PatchV1JobsJobIdAckSignaturesDateTimeBody>
    export type PatchV1JobsJobIdAckSignaturesDateTimeMutationError = ErrorType<PatchV1JobsJobIdAckSignaturesDateTime400 | PatchV1JobsJobIdAckSignaturesDateTime401 | PatchV1JobsJobIdAckSignaturesDateTime403 | PatchV1JobsJobIdAckSignaturesDateTime404 | PatchV1JobsJobIdAckSignaturesDateTime422 | PatchV1JobsJobIdAckSignaturesDateTime500>
    export type PatchV1JobsJobIdAckSignaturesDateTimeMutationVariables = {jobId: string;data: BodyType<PatchV1JobsJobIdAckSignaturesDateTimeBody>}

    export const usePatchV1JobsJobIdAckSignaturesDateTime = <TError = ErrorType<PatchV1JobsJobIdAckSignaturesDateTime400 | PatchV1JobsJobIdAckSignaturesDateTime401 | PatchV1JobsJobIdAckSignaturesDateTime403 | PatchV1JobsJobIdAckSignaturesDateTime404 | PatchV1JobsJobIdAckSignaturesDateTime422 | PatchV1JobsJobIdAckSignaturesDateTime500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchV1JobsJobIdAckSignaturesDateTime>>, TError,PatchV1JobsJobIdAckSignaturesDateTimeMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchV1JobsJobIdAckSignaturesDateTime>>,
        TError,
        PatchV1JobsJobIdAckSignaturesDateTimeMutationVariables,
        TContext
      > => {
      return useMutation(getPatchV1JobsJobIdAckSignaturesDateTimeMutationOptions(options), queryClient);
    }
    /**
 * The copy of every interstate bill of lading page
 */
export const getV1PaperworkContent = (

 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1PaperworkContent200>(
      {url: `/v1/paperwork/content`, method: 'GET', signal
    },
      options);
    }




export const getGetV1PaperworkContentQueryKey = () => {
    return [
    `/v1/paperwork/content`
    ] as const;
    }


export const getGetV1PaperworkContentQueryOptions = <TData = Awaited<ReturnType<typeof getV1PaperworkContent>>, TError = ErrorType<GetV1PaperworkContent400 | GetV1PaperworkContent401 | GetV1PaperworkContent403 | GetV1PaperworkContent404 | GetV1PaperworkContent422 | GetV1PaperworkContent500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContent>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1PaperworkContentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1PaperworkContent>>> = ({ signal }) => getV1PaperworkContent(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1PaperworkContentQueryResult = NonNullable<Awaited<ReturnType<typeof getV1PaperworkContent>>>
export type GetV1PaperworkContentQueryError = ErrorType<GetV1PaperworkContent400 | GetV1PaperworkContent401 | GetV1PaperworkContent403 | GetV1PaperworkContent404 | GetV1PaperworkContent422 | GetV1PaperworkContent500>


export function useGetV1PaperworkContent<TData = Awaited<ReturnType<typeof getV1PaperworkContent>>, TError = ErrorType<GetV1PaperworkContent400 | GetV1PaperworkContent401 | GetV1PaperworkContent403 | GetV1PaperworkContent404 | GetV1PaperworkContent422 | GetV1PaperworkContent500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1PaperworkContent>>,
          TError,
          Awaited<ReturnType<typeof getV1PaperworkContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1PaperworkContent<TData = Awaited<ReturnType<typeof getV1PaperworkContent>>, TError = ErrorType<GetV1PaperworkContent400 | GetV1PaperworkContent401 | GetV1PaperworkContent403 | GetV1PaperworkContent404 | GetV1PaperworkContent422 | GetV1PaperworkContent500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1PaperworkContent>>,
          TError,
          Awaited<ReturnType<typeof getV1PaperworkContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1PaperworkContent<TData = Awaited<ReturnType<typeof getV1PaperworkContent>>, TError = ErrorType<GetV1PaperworkContent400 | GetV1PaperworkContent401 | GetV1PaperworkContent403 | GetV1PaperworkContent404 | GetV1PaperworkContent422 | GetV1PaperworkContent500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContent>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1PaperworkContent<TData = Awaited<ReturnType<typeof getV1PaperworkContent>>, TError = ErrorType<GetV1PaperworkContent400 | GetV1PaperworkContent401 | GetV1PaperworkContent403 | GetV1PaperworkContent404 | GetV1PaperworkContent422 | GetV1PaperworkContent500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContent>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1PaperworkContentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The customer's email and phone on file
 */
export const getV1PaperworkContentCustomerContacts = (

 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1PaperworkContentCustomerContacts200>(
      {url: `/v1/paperwork/content/customer-contacts`, method: 'GET', signal
    },
      options);
    }




export const getGetV1PaperworkContentCustomerContactsQueryKey = () => {
    return [
    `/v1/paperwork/content/customer-contacts`
    ] as const;
    }


export const getGetV1PaperworkContentCustomerContactsQueryOptions = <TData = Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError = ErrorType<GetV1PaperworkContentCustomerContacts400 | GetV1PaperworkContentCustomerContacts401 | GetV1PaperworkContentCustomerContacts403 | GetV1PaperworkContentCustomerContacts404 | GetV1PaperworkContentCustomerContacts422 | GetV1PaperworkContentCustomerContacts500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1PaperworkContentCustomerContactsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>> = ({ signal }) => getV1PaperworkContentCustomerContacts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1PaperworkContentCustomerContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>>
export type GetV1PaperworkContentCustomerContactsQueryError = ErrorType<GetV1PaperworkContentCustomerContacts400 | GetV1PaperworkContentCustomerContacts401 | GetV1PaperworkContentCustomerContacts403 | GetV1PaperworkContentCustomerContacts404 | GetV1PaperworkContentCustomerContacts422 | GetV1PaperworkContentCustomerContacts500>


export function useGetV1PaperworkContentCustomerContacts<TData = Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError = ErrorType<GetV1PaperworkContentCustomerContacts400 | GetV1PaperworkContentCustomerContacts401 | GetV1PaperworkContentCustomerContacts403 | GetV1PaperworkContentCustomerContacts404 | GetV1PaperworkContentCustomerContacts422 | GetV1PaperworkContentCustomerContacts500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>,
          TError,
          Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1PaperworkContentCustomerContacts<TData = Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError = ErrorType<GetV1PaperworkContentCustomerContacts400 | GetV1PaperworkContentCustomerContacts401 | GetV1PaperworkContentCustomerContacts403 | GetV1PaperworkContentCustomerContacts404 | GetV1PaperworkContentCustomerContacts422 | GetV1PaperworkContentCustomerContacts500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>,
          TError,
          Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1PaperworkContentCustomerContacts<TData = Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError = ErrorType<GetV1PaperworkContentCustomerContacts400 | GetV1PaperworkContentCustomerContacts401 | GetV1PaperworkContentCustomerContacts403 | GetV1PaperworkContentCustomerContacts404 | GetV1PaperworkContentCustomerContacts422 | GetV1PaperworkContentCustomerContacts500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1PaperworkContentCustomerContacts<TData = Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError = ErrorType<GetV1PaperworkContentCustomerContacts400 | GetV1PaperworkContentCustomerContacts401 | GetV1PaperworkContentCustomerContacts403 | GetV1PaperworkContentCustomerContacts404 | GetV1PaperworkContentCustomerContacts422 | GetV1PaperworkContentCustomerContacts500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentCustomerContacts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1PaperworkContentCustomerContactsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update the customer's email and phone while the bill of lading is still open
 */
export const putV1JobsJobIdBolCustomerContacts = (
    jobId: string,
    putV1JobsJobIdBolCustomerContactsBody: BodyType<PutV1JobsJobIdBolCustomerContactsBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PutV1JobsJobIdBolCustomerContacts200>(
      {url: `/v1/jobs/${jobId}/bol/customer/contacts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV1JobsJobIdBolCustomerContactsBody, signal
    },
      options);
    }




export const getPutV1JobsJobIdBolCustomerContactsMutationKey = () => ['putV1JobsJobIdBolCustomerContacts'] as const;

export const getPutV1JobsJobIdBolCustomerContactsMutationOptions = <TError = ErrorType<PutV1JobsJobIdBolCustomerContacts400 | PutV1JobsJobIdBolCustomerContacts401 | PutV1JobsJobIdBolCustomerContacts403 | PutV1JobsJobIdBolCustomerContacts404 | PutV1JobsJobIdBolCustomerContacts422 | PutV1JobsJobIdBolCustomerContacts500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolCustomerContacts>>, TError,PutV1JobsJobIdBolCustomerContactsMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolCustomerContacts>>, TError,PutV1JobsJobIdBolCustomerContactsMutationVariables, TContext> => {

const mutationKey = getPutV1JobsJobIdBolCustomerContactsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV1JobsJobIdBolCustomerContacts>>, PutV1JobsJobIdBolCustomerContactsMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  putV1JobsJobIdBolCustomerContacts(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV1JobsJobIdBolCustomerContactsMutationResult = NonNullable<Awaited<ReturnType<typeof putV1JobsJobIdBolCustomerContacts>>>
    export type PutV1JobsJobIdBolCustomerContactsMutationBody = BodyType<PutV1JobsJobIdBolCustomerContactsBody>
    export type PutV1JobsJobIdBolCustomerContactsMutationError = ErrorType<PutV1JobsJobIdBolCustomerContacts400 | PutV1JobsJobIdBolCustomerContacts401 | PutV1JobsJobIdBolCustomerContacts403 | PutV1JobsJobIdBolCustomerContacts404 | PutV1JobsJobIdBolCustomerContacts422 | PutV1JobsJobIdBolCustomerContacts500>
    export type PutV1JobsJobIdBolCustomerContactsMutationVariables = {jobId: string;data: BodyType<PutV1JobsJobIdBolCustomerContactsBody>}

    export const usePutV1JobsJobIdBolCustomerContacts = <TError = ErrorType<PutV1JobsJobIdBolCustomerContacts400 | PutV1JobsJobIdBolCustomerContacts401 | PutV1JobsJobIdBolCustomerContacts403 | PutV1JobsJobIdBolCustomerContacts404 | PutV1JobsJobIdBolCustomerContacts422 | PutV1JobsJobIdBolCustomerContacts500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolCustomerContacts>>, TError,PutV1JobsJobIdBolCustomerContactsMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV1JobsJobIdBolCustomerContacts>>,
        TError,
        PutV1JobsJobIdBolCustomerContactsMutationVariables,
        TContext
      > => {
      return useMutation(getPutV1JobsJobIdBolCustomerContactsMutationOptions(options), queryClient);
    }
    /**
 * Carrier, shipper, consignee and service date blocks of the interstate bill of lading
 */
export const getV1JobsJobIdBolDetail = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdBolDetail200>(
      {url: `/v1/jobs/${jobId}/bol/detail`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdBolDetailQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/bol/detail`
    ] as const;
    }


export const getGetV1JobsJobIdBolDetailQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError = ErrorType<GetV1JobsJobIdBolDetail400 | GetV1JobsJobIdBolDetail401 | GetV1JobsJobIdBolDetail403 | GetV1JobsJobIdBolDetail404 | GetV1JobsJobIdBolDetail422 | GetV1JobsJobIdBolDetail500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdBolDetailQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>> = ({ signal }) => getV1JobsJobIdBolDetail(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdBolDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>>
export type GetV1JobsJobIdBolDetailQueryError = ErrorType<GetV1JobsJobIdBolDetail400 | GetV1JobsJobIdBolDetail401 | GetV1JobsJobIdBolDetail403 | GetV1JobsJobIdBolDetail404 | GetV1JobsJobIdBolDetail422 | GetV1JobsJobIdBolDetail500>


export function useGetV1JobsJobIdBolDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError = ErrorType<GetV1JobsJobIdBolDetail400 | GetV1JobsJobIdBolDetail401 | GetV1JobsJobIdBolDetail403 | GetV1JobsJobIdBolDetail404 | GetV1JobsJobIdBolDetail422 | GetV1JobsJobIdBolDetail500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError = ErrorType<GetV1JobsJobIdBolDetail400 | GetV1JobsJobIdBolDetail401 | GetV1JobsJobIdBolDetail403 | GetV1JobsJobIdBolDetail404 | GetV1JobsJobIdBolDetail422 | GetV1JobsJobIdBolDetail500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError = ErrorType<GetV1JobsJobIdBolDetail400 | GetV1JobsJobIdBolDetail401 | GetV1JobsJobIdBolDetail403 | GetV1JobsJobIdBolDetail404 | GetV1JobsJobIdBolDetail422 | GetV1JobsJobIdBolDetail500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdBolDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError = ErrorType<GetV1JobsJobIdBolDetail400 | GetV1JobsJobIdBolDetail401 | GetV1JobsJobIdBolDetail403 | GetV1JobsJobIdBolDetail404 | GetV1JobsJobIdBolDetail422 | GetV1JobsJobIdBolDetail500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolDetail>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdBolDetailQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The move facts and estimated charges the customer accepts
 */
export const getV1JobsJobIdBolMoveDetail = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdBolMoveDetail200>(
      {url: `/v1/jobs/${jobId}/bol/move-detail`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdBolMoveDetailQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/bol/move-detail`
    ] as const;
    }


export const getGetV1JobsJobIdBolMoveDetailQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError = ErrorType<GetV1JobsJobIdBolMoveDetail400 | GetV1JobsJobIdBolMoveDetail401 | GetV1JobsJobIdBolMoveDetail403 | GetV1JobsJobIdBolMoveDetail404 | GetV1JobsJobIdBolMoveDetail422 | GetV1JobsJobIdBolMoveDetail500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdBolMoveDetailQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>> = ({ signal }) => getV1JobsJobIdBolMoveDetail(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdBolMoveDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>>
export type GetV1JobsJobIdBolMoveDetailQueryError = ErrorType<GetV1JobsJobIdBolMoveDetail400 | GetV1JobsJobIdBolMoveDetail401 | GetV1JobsJobIdBolMoveDetail403 | GetV1JobsJobIdBolMoveDetail404 | GetV1JobsJobIdBolMoveDetail422 | GetV1JobsJobIdBolMoveDetail500>


export function useGetV1JobsJobIdBolMoveDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError = ErrorType<GetV1JobsJobIdBolMoveDetail400 | GetV1JobsJobIdBolMoveDetail401 | GetV1JobsJobIdBolMoveDetail403 | GetV1JobsJobIdBolMoveDetail404 | GetV1JobsJobIdBolMoveDetail422 | GetV1JobsJobIdBolMoveDetail500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolMoveDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError = ErrorType<GetV1JobsJobIdBolMoveDetail400 | GetV1JobsJobIdBolMoveDetail401 | GetV1JobsJobIdBolMoveDetail403 | GetV1JobsJobIdBolMoveDetail404 | GetV1JobsJobIdBolMoveDetail422 | GetV1JobsJobIdBolMoveDetail500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolMoveDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError = ErrorType<GetV1JobsJobIdBolMoveDetail400 | GetV1JobsJobIdBolMoveDetail401 | GetV1JobsJobIdBolMoveDetail403 | GetV1JobsJobIdBolMoveDetail404 | GetV1JobsJobIdBolMoveDetail422 | GetV1JobsJobIdBolMoveDetail500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdBolMoveDetail<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError = ErrorType<GetV1JobsJobIdBolMoveDetail400 | GetV1JobsJobIdBolMoveDetail401 | GetV1JobsJobIdBolMoveDetail403 | GetV1JobsJobIdBolMoveDetail404 | GetV1JobsJobIdBolMoveDetail422 | GetV1JobsJobIdBolMoveDetail500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolMoveDetail>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdBolMoveDetailQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Every packing material across the move with its quantity
 */
export const getV1PaperworkContentPackingMaterials = (

 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1PaperworkContentPackingMaterials200>(
      {url: `/v1/paperwork/content/packing-materials`, method: 'GET', signal
    },
      options);
    }




export const getGetV1PaperworkContentPackingMaterialsQueryKey = () => {
    return [
    `/v1/paperwork/content/packing-materials`
    ] as const;
    }


export const getGetV1PaperworkContentPackingMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError = ErrorType<GetV1PaperworkContentPackingMaterials400 | GetV1PaperworkContentPackingMaterials401 | GetV1PaperworkContentPackingMaterials403 | GetV1PaperworkContentPackingMaterials404 | GetV1PaperworkContentPackingMaterials422 | GetV1PaperworkContentPackingMaterials500>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1PaperworkContentPackingMaterialsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>> = ({ signal }) => getV1PaperworkContentPackingMaterials(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1PaperworkContentPackingMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>>
export type GetV1PaperworkContentPackingMaterialsQueryError = ErrorType<GetV1PaperworkContentPackingMaterials400 | GetV1PaperworkContentPackingMaterials401 | GetV1PaperworkContentPackingMaterials403 | GetV1PaperworkContentPackingMaterials404 | GetV1PaperworkContentPackingMaterials422 | GetV1PaperworkContentPackingMaterials500>


export function useGetV1PaperworkContentPackingMaterials<TData = Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError = ErrorType<GetV1PaperworkContentPackingMaterials400 | GetV1PaperworkContentPackingMaterials401 | GetV1PaperworkContentPackingMaterials403 | GetV1PaperworkContentPackingMaterials404 | GetV1PaperworkContentPackingMaterials422 | GetV1PaperworkContentPackingMaterials500>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>,
          TError,
          Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1PaperworkContentPackingMaterials<TData = Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError = ErrorType<GetV1PaperworkContentPackingMaterials400 | GetV1PaperworkContentPackingMaterials401 | GetV1PaperworkContentPackingMaterials403 | GetV1PaperworkContentPackingMaterials404 | GetV1PaperworkContentPackingMaterials422 | GetV1PaperworkContentPackingMaterials500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>,
          TError,
          Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1PaperworkContentPackingMaterials<TData = Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError = ErrorType<GetV1PaperworkContentPackingMaterials400 | GetV1PaperworkContentPackingMaterials401 | GetV1PaperworkContentPackingMaterials403 | GetV1PaperworkContentPackingMaterials404 | GetV1PaperworkContentPackingMaterials422 | GetV1PaperworkContentPackingMaterials500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1PaperworkContentPackingMaterials<TData = Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError = ErrorType<GetV1PaperworkContentPackingMaterials400 | GetV1PaperworkContentPackingMaterials401 | GetV1PaperworkContentPackingMaterials403 | GetV1PaperworkContentPackingMaterials404 | GetV1PaperworkContentPackingMaterials422 | GetV1PaperworkContentPackingMaterials500>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1PaperworkContentPackingMaterials>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1PaperworkContentPackingMaterialsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The valuation options of the move and what the customer picked so far
 */
export const getV1JobsJobIdBolValuation = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdBolValuation200>(
      {url: `/v1/jobs/${jobId}/bol/valuation`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdBolValuationQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/bol/valuation`
    ] as const;
    }


export const getGetV1JobsJobIdBolValuationQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError = ErrorType<GetV1JobsJobIdBolValuation400 | GetV1JobsJobIdBolValuation401 | GetV1JobsJobIdBolValuation403 | GetV1JobsJobIdBolValuation404 | GetV1JobsJobIdBolValuation422 | GetV1JobsJobIdBolValuation500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdBolValuationQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>> = ({ signal }) => getV1JobsJobIdBolValuation(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdBolValuationQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>>
export type GetV1JobsJobIdBolValuationQueryError = ErrorType<GetV1JobsJobIdBolValuation400 | GetV1JobsJobIdBolValuation401 | GetV1JobsJobIdBolValuation403 | GetV1JobsJobIdBolValuation404 | GetV1JobsJobIdBolValuation422 | GetV1JobsJobIdBolValuation500>


export function useGetV1JobsJobIdBolValuation<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError = ErrorType<GetV1JobsJobIdBolValuation400 | GetV1JobsJobIdBolValuation401 | GetV1JobsJobIdBolValuation403 | GetV1JobsJobIdBolValuation404 | GetV1JobsJobIdBolValuation422 | GetV1JobsJobIdBolValuation500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolValuation<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError = ErrorType<GetV1JobsJobIdBolValuation400 | GetV1JobsJobIdBolValuation401 | GetV1JobsJobIdBolValuation403 | GetV1JobsJobIdBolValuation404 | GetV1JobsJobIdBolValuation422 | GetV1JobsJobIdBolValuation500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolValuation<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError = ErrorType<GetV1JobsJobIdBolValuation400 | GetV1JobsJobIdBolValuation401 | GetV1JobsJobIdBolValuation403 | GetV1JobsJobIdBolValuation404 | GetV1JobsJobIdBolValuation422 | GetV1JobsJobIdBolValuation500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdBolValuation<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError = ErrorType<GetV1JobsJobIdBolValuation400 | GetV1JobsJobIdBolValuation401 | GetV1JobsJobIdBolValuation403 | GetV1JobsJobIdBolValuation404 | GetV1JobsJobIdBolValuation422 | GetV1JobsJobIdBolValuation500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolValuation>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdBolValuationQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Record the customer's valuation choice and re-price the move
 */
export const putV1JobsJobIdBolValuation = (
    jobId: string,
    putV1JobsJobIdBolValuationBody: BodyType<PutV1JobsJobIdBolValuationBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PutV1JobsJobIdBolValuation200>(
      {url: `/v1/jobs/${jobId}/bol/valuation`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV1JobsJobIdBolValuationBody, signal
    },
      options);
    }




export const getPutV1JobsJobIdBolValuationMutationKey = () => ['putV1JobsJobIdBolValuation'] as const;

export const getPutV1JobsJobIdBolValuationMutationOptions = <TError = ErrorType<PutV1JobsJobIdBolValuation400 | PutV1JobsJobIdBolValuation401 | PutV1JobsJobIdBolValuation403 | PutV1JobsJobIdBolValuation404 | PutV1JobsJobIdBolValuation422 | PutV1JobsJobIdBolValuation500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolValuation>>, TError,PutV1JobsJobIdBolValuationMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolValuation>>, TError,PutV1JobsJobIdBolValuationMutationVariables, TContext> => {

const mutationKey = getPutV1JobsJobIdBolValuationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV1JobsJobIdBolValuation>>, PutV1JobsJobIdBolValuationMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  putV1JobsJobIdBolValuation(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV1JobsJobIdBolValuationMutationResult = NonNullable<Awaited<ReturnType<typeof putV1JobsJobIdBolValuation>>>
    export type PutV1JobsJobIdBolValuationMutationBody = BodyType<PutV1JobsJobIdBolValuationBody>
    export type PutV1JobsJobIdBolValuationMutationError = ErrorType<PutV1JobsJobIdBolValuation400 | PutV1JobsJobIdBolValuation401 | PutV1JobsJobIdBolValuation403 | PutV1JobsJobIdBolValuation404 | PutV1JobsJobIdBolValuation422 | PutV1JobsJobIdBolValuation500>
    export type PutV1JobsJobIdBolValuationMutationVariables = {jobId: string;data: BodyType<PutV1JobsJobIdBolValuationBody>}

    export const usePutV1JobsJobIdBolValuation = <TError = ErrorType<PutV1JobsJobIdBolValuation400 | PutV1JobsJobIdBolValuation401 | PutV1JobsJobIdBolValuation403 | PutV1JobsJobIdBolValuation404 | PutV1JobsJobIdBolValuation422 | PutV1JobsJobIdBolValuation500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolValuation>>, TError,PutV1JobsJobIdBolValuationMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV1JobsJobIdBolValuation>>,
        TError,
        PutV1JobsJobIdBolValuationMutationVariables,
        TContext
      > => {
      return useMutation(getPutV1JobsJobIdBolValuationMutationOptions(options), queryClient);
    }
    /**
 * The premium for a declared value and the move cost it brings the total to
 */
export const postV1JobsJobIdBolValuationPremium = (
    jobId: string,
    postV1JobsJobIdBolValuationPremiumBody: BodyType<PostV1JobsJobIdBolValuationPremiumBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PostV1JobsJobIdBolValuationPremium200>(
      {url: `/v1/jobs/${jobId}/bol/valuation/premium`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postV1JobsJobIdBolValuationPremiumBody, signal
    },
      options);
    }




export const getPostV1JobsJobIdBolValuationPremiumMutationKey = () => ['postV1JobsJobIdBolValuationPremium'] as const;

export const getPostV1JobsJobIdBolValuationPremiumMutationOptions = <TError = ErrorType<PostV1JobsJobIdBolValuationPremium400 | PostV1JobsJobIdBolValuationPremium401 | PostV1JobsJobIdBolValuationPremium403 | PostV1JobsJobIdBolValuationPremium404 | PostV1JobsJobIdBolValuationPremium422 | PostV1JobsJobIdBolValuationPremium500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolValuationPremium>>, TError,PostV1JobsJobIdBolValuationPremiumMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolValuationPremium>>, TError,PostV1JobsJobIdBolValuationPremiumMutationVariables, TContext> => {

const mutationKey = getPostV1JobsJobIdBolValuationPremiumMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV1JobsJobIdBolValuationPremium>>, PostV1JobsJobIdBolValuationPremiumMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  postV1JobsJobIdBolValuationPremium(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV1JobsJobIdBolValuationPremiumMutationResult = NonNullable<Awaited<ReturnType<typeof postV1JobsJobIdBolValuationPremium>>>
    export type PostV1JobsJobIdBolValuationPremiumMutationBody = BodyType<PostV1JobsJobIdBolValuationPremiumBody>
    export type PostV1JobsJobIdBolValuationPremiumMutationError = ErrorType<PostV1JobsJobIdBolValuationPremium400 | PostV1JobsJobIdBolValuationPremium401 | PostV1JobsJobIdBolValuationPremium403 | PostV1JobsJobIdBolValuationPremium404 | PostV1JobsJobIdBolValuationPremium422 | PostV1JobsJobIdBolValuationPremium500>
    export type PostV1JobsJobIdBolValuationPremiumMutationVariables = {jobId: string;data: BodyType<PostV1JobsJobIdBolValuationPremiumBody>}

    export const usePostV1JobsJobIdBolValuationPremium = <TError = ErrorType<PostV1JobsJobIdBolValuationPremium400 | PostV1JobsJobIdBolValuationPremium401 | PostV1JobsJobIdBolValuationPremium403 | PostV1JobsJobIdBolValuationPremium404 | PostV1JobsJobIdBolValuationPremium422 | PostV1JobsJobIdBolValuationPremium500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolValuationPremium>>, TError,PostV1JobsJobIdBolValuationPremiumMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV1JobsJobIdBolValuationPremium>>,
        TError,
        PostV1JobsJobIdBolValuationPremiumMutationVariables,
        TContext
      > => {
      return useMutation(getPostV1JobsJobIdBolValuationPremiumMutationOptions(options), queryClient);
    }
    /**
 * Which bill of lading screens are signed, which are left, and the status log
 */
export const getV1JobsJobIdBolSignatures = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdBolSignatures200>(
      {url: `/v1/jobs/${jobId}/bol/signatures`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdBolSignaturesQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/bol/signatures`
    ] as const;
    }


export const getGetV1JobsJobIdBolSignaturesQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError = ErrorType<GetV1JobsJobIdBolSignatures400 | GetV1JobsJobIdBolSignatures401 | GetV1JobsJobIdBolSignatures403 | GetV1JobsJobIdBolSignatures404 | GetV1JobsJobIdBolSignatures422 | GetV1JobsJobIdBolSignatures500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdBolSignaturesQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>> = ({ signal }) => getV1JobsJobIdBolSignatures(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdBolSignaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>>
export type GetV1JobsJobIdBolSignaturesQueryError = ErrorType<GetV1JobsJobIdBolSignatures400 | GetV1JobsJobIdBolSignatures401 | GetV1JobsJobIdBolSignatures403 | GetV1JobsJobIdBolSignatures404 | GetV1JobsJobIdBolSignatures422 | GetV1JobsJobIdBolSignatures500>


export function useGetV1JobsJobIdBolSignatures<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError = ErrorType<GetV1JobsJobIdBolSignatures400 | GetV1JobsJobIdBolSignatures401 | GetV1JobsJobIdBolSignatures403 | GetV1JobsJobIdBolSignatures404 | GetV1JobsJobIdBolSignatures422 | GetV1JobsJobIdBolSignatures500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolSignatures<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError = ErrorType<GetV1JobsJobIdBolSignatures400 | GetV1JobsJobIdBolSignatures401 | GetV1JobsJobIdBolSignatures403 | GetV1JobsJobIdBolSignatures404 | GetV1JobsJobIdBolSignatures422 | GetV1JobsJobIdBolSignatures500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolSignatures<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError = ErrorType<GetV1JobsJobIdBolSignatures400 | GetV1JobsJobIdBolSignatures401 | GetV1JobsJobIdBolSignatures403 | GetV1JobsJobIdBolSignatures404 | GetV1JobsJobIdBolSignatures422 | GetV1JobsJobIdBolSignatures500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdBolSignatures<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError = ErrorType<GetV1JobsJobIdBolSignatures400 | GetV1JobsJobIdBolSignatures401 | GetV1JobsJobIdBolSignatures403 | GetV1JobsJobIdBolSignatures404 | GetV1JobsJobIdBolSignatures422 | GetV1JobsJobIdBolSignatures500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolSignatures>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdBolSignaturesQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * An upload url for the signature of a bill of lading screen
 */
export const postV1JobsJobIdBolSignaturesUploadUrl = (
    jobId: string,
    postV1JobsJobIdBolSignaturesUploadUrlBody: BodyType<PostV1JobsJobIdBolSignaturesUploadUrlBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PostV1JobsJobIdBolSignaturesUploadUrl200>(
      {url: `/v1/jobs/${jobId}/bol/signatures/upload-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postV1JobsJobIdBolSignaturesUploadUrlBody, signal
    },
      options);
    }




export const getPostV1JobsJobIdBolSignaturesUploadUrlMutationKey = () => ['postV1JobsJobIdBolSignaturesUploadUrl'] as const;

export const getPostV1JobsJobIdBolSignaturesUploadUrlMutationOptions = <TError = ErrorType<PostV1JobsJobIdBolSignaturesUploadUrl400 | PostV1JobsJobIdBolSignaturesUploadUrl401 | PostV1JobsJobIdBolSignaturesUploadUrl403 | PostV1JobsJobIdBolSignaturesUploadUrl404 | PostV1JobsJobIdBolSignaturesUploadUrl422 | PostV1JobsJobIdBolSignaturesUploadUrl500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesUploadUrl>>, TError,PostV1JobsJobIdBolSignaturesUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesUploadUrl>>, TError,PostV1JobsJobIdBolSignaturesUploadUrlMutationVariables, TContext> => {

const mutationKey = getPostV1JobsJobIdBolSignaturesUploadUrlMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesUploadUrl>>, PostV1JobsJobIdBolSignaturesUploadUrlMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  postV1JobsJobIdBolSignaturesUploadUrl(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV1JobsJobIdBolSignaturesUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesUploadUrl>>>
    export type PostV1JobsJobIdBolSignaturesUploadUrlMutationBody = BodyType<PostV1JobsJobIdBolSignaturesUploadUrlBody>
    export type PostV1JobsJobIdBolSignaturesUploadUrlMutationError = ErrorType<PostV1JobsJobIdBolSignaturesUploadUrl400 | PostV1JobsJobIdBolSignaturesUploadUrl401 | PostV1JobsJobIdBolSignaturesUploadUrl403 | PostV1JobsJobIdBolSignaturesUploadUrl404 | PostV1JobsJobIdBolSignaturesUploadUrl422 | PostV1JobsJobIdBolSignaturesUploadUrl500>
    export type PostV1JobsJobIdBolSignaturesUploadUrlMutationVariables = {jobId: string;data: BodyType<PostV1JobsJobIdBolSignaturesUploadUrlBody>}

    export const usePostV1JobsJobIdBolSignaturesUploadUrl = <TError = ErrorType<PostV1JobsJobIdBolSignaturesUploadUrl400 | PostV1JobsJobIdBolSignaturesUploadUrl401 | PostV1JobsJobIdBolSignaturesUploadUrl403 | PostV1JobsJobIdBolSignaturesUploadUrl404 | PostV1JobsJobIdBolSignaturesUploadUrl422 | PostV1JobsJobIdBolSignaturesUploadUrl500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesUploadUrl>>, TError,PostV1JobsJobIdBolSignaturesUploadUrlMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesUploadUrl>>,
        TError,
        PostV1JobsJobIdBolSignaturesUploadUrlMutationVariables,
        TContext
      > => {
      return useMutation(getPostV1JobsJobIdBolSignaturesUploadUrlMutationOptions(options), queryClient);
    }
    /**
 * Record when the customer signed a bill of lading screen
 */
export const putV1JobsJobIdBolSignaturesType2 = (
    jobId: string,
    type2: string,
    putV1JobsJobIdBolSignaturesType2Body: BodyType<PutV1JobsJobIdBolSignaturesType2Body>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PutV1JobsJobIdBolSignaturesType2200>(
      {url: `/v1/jobs/${jobId}/bol/signatures/${type2}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV1JobsJobIdBolSignaturesType2Body, signal
    },
      options);
    }




export const getPutV1JobsJobIdBolSignaturesType2MutationKey = () => ['putV1JobsJobIdBolSignaturesType2'] as const;

export const getPutV1JobsJobIdBolSignaturesType2MutationOptions = <TError = ErrorType<PutV1JobsJobIdBolSignaturesType2400 | PutV1JobsJobIdBolSignaturesType2401 | PutV1JobsJobIdBolSignaturesType2403 | PutV1JobsJobIdBolSignaturesType2404 | PutV1JobsJobIdBolSignaturesType2422 | PutV1JobsJobIdBolSignaturesType2500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolSignaturesType2>>, TError,PutV1JobsJobIdBolSignaturesType2MutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolSignaturesType2>>, TError,PutV1JobsJobIdBolSignaturesType2MutationVariables, TContext> => {

const mutationKey = getPutV1JobsJobIdBolSignaturesType2MutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV1JobsJobIdBolSignaturesType2>>, PutV1JobsJobIdBolSignaturesType2MutationVariables> = (props) => {
          const {jobId,type2,data} = props ?? {};

          return  putV1JobsJobIdBolSignaturesType2(jobId,type2,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV1JobsJobIdBolSignaturesType2MutationResult = NonNullable<Awaited<ReturnType<typeof putV1JobsJobIdBolSignaturesType2>>>
    export type PutV1JobsJobIdBolSignaturesType2MutationBody = BodyType<PutV1JobsJobIdBolSignaturesType2Body>
    export type PutV1JobsJobIdBolSignaturesType2MutationError = ErrorType<PutV1JobsJobIdBolSignaturesType2400 | PutV1JobsJobIdBolSignaturesType2401 | PutV1JobsJobIdBolSignaturesType2403 | PutV1JobsJobIdBolSignaturesType2404 | PutV1JobsJobIdBolSignaturesType2422 | PutV1JobsJobIdBolSignaturesType2500>
    export type PutV1JobsJobIdBolSignaturesType2MutationVariables = {jobId: string;type2: string;data: BodyType<PutV1JobsJobIdBolSignaturesType2Body>}

    export const usePutV1JobsJobIdBolSignaturesType2 = <TError = ErrorType<PutV1JobsJobIdBolSignaturesType2400 | PutV1JobsJobIdBolSignaturesType2401 | PutV1JobsJobIdBolSignaturesType2403 | PutV1JobsJobIdBolSignaturesType2404 | PutV1JobsJobIdBolSignaturesType2422 | PutV1JobsJobIdBolSignaturesType2500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV1JobsJobIdBolSignaturesType2>>, TError,PutV1JobsJobIdBolSignaturesType2MutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV1JobsJobIdBolSignaturesType2>>,
        TError,
        PutV1JobsJobIdBolSignaturesType2MutationVariables,
        TContext
      > => {
      return useMutation(getPutV1JobsJobIdBolSignaturesType2MutationOptions(options), queryClient);
    }
    /**
 * Sign a screen with the signature already drawn for another
 */
export const postV1JobsJobIdBolSignaturesCopy = (
    jobId: string,
    postV1JobsJobIdBolSignaturesCopyBody: BodyType<PostV1JobsJobIdBolSignaturesCopyBody>,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PostV1JobsJobIdBolSignaturesCopy200>(
      {url: `/v1/jobs/${jobId}/bol/signatures/copy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postV1JobsJobIdBolSignaturesCopyBody, signal
    },
      options);
    }




export const getPostV1JobsJobIdBolSignaturesCopyMutationKey = () => ['postV1JobsJobIdBolSignaturesCopy'] as const;

export const getPostV1JobsJobIdBolSignaturesCopyMutationOptions = <TError = ErrorType<PostV1JobsJobIdBolSignaturesCopy400 | PostV1JobsJobIdBolSignaturesCopy401 | PostV1JobsJobIdBolSignaturesCopy403 | PostV1JobsJobIdBolSignaturesCopy404 | PostV1JobsJobIdBolSignaturesCopy422 | PostV1JobsJobIdBolSignaturesCopy500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesCopy>>, TError,PostV1JobsJobIdBolSignaturesCopyMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesCopy>>, TError,PostV1JobsJobIdBolSignaturesCopyMutationVariables, TContext> => {

const mutationKey = getPostV1JobsJobIdBolSignaturesCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesCopy>>, PostV1JobsJobIdBolSignaturesCopyMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  postV1JobsJobIdBolSignaturesCopy(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV1JobsJobIdBolSignaturesCopyMutationResult = NonNullable<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesCopy>>>
    export type PostV1JobsJobIdBolSignaturesCopyMutationBody = BodyType<PostV1JobsJobIdBolSignaturesCopyBody>
    export type PostV1JobsJobIdBolSignaturesCopyMutationError = ErrorType<PostV1JobsJobIdBolSignaturesCopy400 | PostV1JobsJobIdBolSignaturesCopy401 | PostV1JobsJobIdBolSignaturesCopy403 | PostV1JobsJobIdBolSignaturesCopy404 | PostV1JobsJobIdBolSignaturesCopy422 | PostV1JobsJobIdBolSignaturesCopy500>
    export type PostV1JobsJobIdBolSignaturesCopyMutationVariables = {jobId: string;data: BodyType<PostV1JobsJobIdBolSignaturesCopyBody>}

    export const usePostV1JobsJobIdBolSignaturesCopy = <TError = ErrorType<PostV1JobsJobIdBolSignaturesCopy400 | PostV1JobsJobIdBolSignaturesCopy401 | PostV1JobsJobIdBolSignaturesCopy403 | PostV1JobsJobIdBolSignaturesCopy404 | PostV1JobsJobIdBolSignaturesCopy422 | PostV1JobsJobIdBolSignaturesCopy500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesCopy>>, TError,PostV1JobsJobIdBolSignaturesCopyMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV1JobsJobIdBolSignaturesCopy>>,
        TError,
        PostV1JobsJobIdBolSignaturesCopyMutationVariables,
        TContext
      > => {
      return useMutation(getPostV1JobsJobIdBolSignaturesCopyMutationOptions(options), queryClient);
    }
    /**
 * Close the bill of lading once every screen is signed
 */
export const postV1JobsJobIdBolComplete = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PostV1JobsJobIdBolComplete200>(
      {url: `/v1/jobs/${jobId}/bol/complete`, method: 'POST', signal
    },
      options);
    }




export const getPostV1JobsJobIdBolCompleteMutationKey = () => ['postV1JobsJobIdBolComplete'] as const;

export const getPostV1JobsJobIdBolCompleteMutationOptions = <TError = ErrorType<PostV1JobsJobIdBolComplete400 | PostV1JobsJobIdBolComplete401 | PostV1JobsJobIdBolComplete403 | PostV1JobsJobIdBolComplete404 | PostV1JobsJobIdBolComplete422 | PostV1JobsJobIdBolComplete500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolComplete>>, TError,PostV1JobsJobIdBolCompleteMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolComplete>>, TError,PostV1JobsJobIdBolCompleteMutationVariables, TContext> => {

const mutationKey = getPostV1JobsJobIdBolCompleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV1JobsJobIdBolComplete>>, PostV1JobsJobIdBolCompleteMutationVariables> = (props) => {
          const {jobId} = props ?? {};

          return  postV1JobsJobIdBolComplete(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV1JobsJobIdBolCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postV1JobsJobIdBolComplete>>>

    export type PostV1JobsJobIdBolCompleteMutationError = ErrorType<PostV1JobsJobIdBolComplete400 | PostV1JobsJobIdBolComplete401 | PostV1JobsJobIdBolComplete403 | PostV1JobsJobIdBolComplete404 | PostV1JobsJobIdBolComplete422 | PostV1JobsJobIdBolComplete500>
    export type PostV1JobsJobIdBolCompleteMutationVariables = {jobId: string}

    export const usePostV1JobsJobIdBolComplete = <TError = ErrorType<PostV1JobsJobIdBolComplete400 | PostV1JobsJobIdBolComplete401 | PostV1JobsJobIdBolComplete403 | PostV1JobsJobIdBolComplete404 | PostV1JobsJobIdBolComplete422 | PostV1JobsJobIdBolComplete500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolComplete>>, TError,PostV1JobsJobIdBolCompleteMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV1JobsJobIdBolComplete>>,
        TError,
        PostV1JobsJobIdBolCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getPostV1JobsJobIdBolCompleteMutationOptions(options), queryClient);
    }
    /**
 * Build the signed bill of lading PDF and email it to the customer
 */
export const postV1JobsJobIdBolEmail = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PostV1JobsJobIdBolEmail200>(
      {url: `/v1/jobs/${jobId}/bol/email`, method: 'POST', signal
    },
      options);
    }




export const getPostV1JobsJobIdBolEmailMutationKey = () => ['postV1JobsJobIdBolEmail'] as const;

export const getPostV1JobsJobIdBolEmailMutationOptions = <TError = ErrorType<PostV1JobsJobIdBolEmail400 | PostV1JobsJobIdBolEmail401 | PostV1JobsJobIdBolEmail403 | PostV1JobsJobIdBolEmail404 | PostV1JobsJobIdBolEmail422 | PostV1JobsJobIdBolEmail500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolEmail>>, TError,PostV1JobsJobIdBolEmailMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolEmail>>, TError,PostV1JobsJobIdBolEmailMutationVariables, TContext> => {

const mutationKey = getPostV1JobsJobIdBolEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV1JobsJobIdBolEmail>>, PostV1JobsJobIdBolEmailMutationVariables> = (props) => {
          const {jobId} = props ?? {};

          return  postV1JobsJobIdBolEmail(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV1JobsJobIdBolEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postV1JobsJobIdBolEmail>>>

    export type PostV1JobsJobIdBolEmailMutationError = ErrorType<PostV1JobsJobIdBolEmail400 | PostV1JobsJobIdBolEmail401 | PostV1JobsJobIdBolEmail403 | PostV1JobsJobIdBolEmail404 | PostV1JobsJobIdBolEmail422 | PostV1JobsJobIdBolEmail500>
    export type PostV1JobsJobIdBolEmailMutationVariables = {jobId: string}

    export const usePostV1JobsJobIdBolEmail = <TError = ErrorType<PostV1JobsJobIdBolEmail400 | PostV1JobsJobIdBolEmail401 | PostV1JobsJobIdBolEmail403 | PostV1JobsJobIdBolEmail404 | PostV1JobsJobIdBolEmail422 | PostV1JobsJobIdBolEmail500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolEmail>>, TError,PostV1JobsJobIdBolEmailMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV1JobsJobIdBolEmail>>,
        TError,
        PostV1JobsJobIdBolEmailMutationVariables,
        TContext
      > => {
      return useMutation(getPostV1JobsJobIdBolEmailMutationOptions(options), queryClient);
    }
    /**
 * Who the customer can call during the move
 */
export const getV1JobsJobIdBolContacts = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<GetV1JobsJobIdBolContacts200>(
      {url: `/v1/jobs/${jobId}/bol/contacts`, method: 'GET', signal
    },
      options);
    }




export const getGetV1JobsJobIdBolContactsQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/bol/contacts`
    ] as const;
    }


export const getGetV1JobsJobIdBolContactsQueryOptions = <TData = Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError = ErrorType<GetV1JobsJobIdBolContacts400 | GetV1JobsJobIdBolContacts401 | GetV1JobsJobIdBolContacts403 | GetV1JobsJobIdBolContacts404 | GetV1JobsJobIdBolContacts422 | GetV1JobsJobIdBolContacts500>>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV1JobsJobIdBolContactsQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>> = ({ signal }) => getV1JobsJobIdBolContacts(jobId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV1JobsJobIdBolContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>>
export type GetV1JobsJobIdBolContactsQueryError = ErrorType<GetV1JobsJobIdBolContacts400 | GetV1JobsJobIdBolContacts401 | GetV1JobsJobIdBolContacts403 | GetV1JobsJobIdBolContacts404 | GetV1JobsJobIdBolContacts422 | GetV1JobsJobIdBolContacts500>


export function useGetV1JobsJobIdBolContacts<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError = ErrorType<GetV1JobsJobIdBolContacts400 | GetV1JobsJobIdBolContacts401 | GetV1JobsJobIdBolContacts403 | GetV1JobsJobIdBolContacts404 | GetV1JobsJobIdBolContacts422 | GetV1JobsJobIdBolContacts500>>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolContacts<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError = ErrorType<GetV1JobsJobIdBolContacts400 | GetV1JobsJobIdBolContacts401 | GetV1JobsJobIdBolContacts403 | GetV1JobsJobIdBolContacts404 | GetV1JobsJobIdBolContacts422 | GetV1JobsJobIdBolContacts500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>,
          TError,
          Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV1JobsJobIdBolContacts<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError = ErrorType<GetV1JobsJobIdBolContacts400 | GetV1JobsJobIdBolContacts401 | GetV1JobsJobIdBolContacts403 | GetV1JobsJobIdBolContacts404 | GetV1JobsJobIdBolContacts422 | GetV1JobsJobIdBolContacts500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetV1JobsJobIdBolContacts<TData = Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError = ErrorType<GetV1JobsJobIdBolContacts400 | GetV1JobsJobIdBolContacts401 | GetV1JobsJobIdBolContacts403 | GetV1JobsJobIdBolContacts404 | GetV1JobsJobIdBolContacts422 | GetV1JobsJobIdBolContacts500>>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV1JobsJobIdBolContacts>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV1JobsJobIdBolContactsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Text the contact list to the customer
 */
export const postV1JobsJobIdBolContactsSend = (
    jobId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PostV1JobsJobIdBolContactsSend200>(
      {url: `/v1/jobs/${jobId}/bol/contacts/send`, method: 'POST', signal
    },
      options);
    }




export const getPostV1JobsJobIdBolContactsSendMutationKey = () => ['postV1JobsJobIdBolContactsSend'] as const;

export const getPostV1JobsJobIdBolContactsSendMutationOptions = <TError = ErrorType<PostV1JobsJobIdBolContactsSend400 | PostV1JobsJobIdBolContactsSend401 | PostV1JobsJobIdBolContactsSend403 | PostV1JobsJobIdBolContactsSend404 | PostV1JobsJobIdBolContactsSend422 | PostV1JobsJobIdBolContactsSend500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolContactsSend>>, TError,PostV1JobsJobIdBolContactsSendMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolContactsSend>>, TError,PostV1JobsJobIdBolContactsSendMutationVariables, TContext> => {

const mutationKey = getPostV1JobsJobIdBolContactsSendMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV1JobsJobIdBolContactsSend>>, PostV1JobsJobIdBolContactsSendMutationVariables> = (props) => {
          const {jobId} = props ?? {};

          return  postV1JobsJobIdBolContactsSend(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV1JobsJobIdBolContactsSendMutationResult = NonNullable<Awaited<ReturnType<typeof postV1JobsJobIdBolContactsSend>>>

    export type PostV1JobsJobIdBolContactsSendMutationError = ErrorType<PostV1JobsJobIdBolContactsSend400 | PostV1JobsJobIdBolContactsSend401 | PostV1JobsJobIdBolContactsSend403 | PostV1JobsJobIdBolContactsSend404 | PostV1JobsJobIdBolContactsSend422 | PostV1JobsJobIdBolContactsSend500>
    export type PostV1JobsJobIdBolContactsSendMutationVariables = {jobId: string}

    export const usePostV1JobsJobIdBolContactsSend = <TError = ErrorType<PostV1JobsJobIdBolContactsSend400 | PostV1JobsJobIdBolContactsSend401 | PostV1JobsJobIdBolContactsSend403 | PostV1JobsJobIdBolContactsSend404 | PostV1JobsJobIdBolContactsSend422 | PostV1JobsJobIdBolContactsSend500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1JobsJobIdBolContactsSend>>, TError,PostV1JobsJobIdBolContactsSendMutationVariables, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV1JobsJobIdBolContactsSend>>,
        TError,
        PostV1JobsJobIdBolContactsSendMutationVariables,
        TContext
      > => {
      return useMutation(getPostV1JobsJobIdBolContactsSendMutationOptions(options), queryClient);
    }
